var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"content":_vm.tooltip}},[_c('BaseButton',_vm._b({staticClass:"edit btn-link",attrs:{"type":_vm.type,"size":_vm.size,"icon":""},on:{"click":_vm.click}},'BaseButton',_vm.$attrs,false),[_c('i',{class:_vm.icon})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }